import React, { useState, useEffect } from 'react';
import './Dice.css';

export default function Dice({ value, rolling, onClick, disabled }) {
  const [localValue, setLocalValue] = useState(value || 1);

  useEffect(() => {
    if (value && !rolling) {
      setLocalValue(value);
    }
  }, [value, rolling]);

  const renderDots = (value) => {
    if (value === 1) return <div className="dot" />;
    return (
      <div className="dot-container">
        {Array.from({ length: 9 }).map((_, i) => (
          <div key={i} className="dot" />
        ))}
      </div>
    );
  };

  return (
    <div 
      className={`dice-container ${disabled ? 'disabled' : ''}`} 
      onClick={!disabled ? onClick : null}
    >
      <div 
        className={`dice ${rolling ? 'rolling' : ''}`} 
        data-value={localValue}
      >
        <div className="dice-face face-1">{renderDots(1)}</div>
        <div className="dice-face face-2">{renderDots(2)}</div>
        <div className="dice-face face-3">{renderDots(3)}</div>
        <div className="dice-face face-4">{renderDots(4)}</div>
        <div className="dice-face face-5">{renderDots(5)}</div>
        <div className="dice-face face-6">{renderDots(6)}</div>
      </div>
    </div>
  );
}
